"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoError = exports.BlankScreen = exports.Playing = exports.Paused = exports.NotApplicable = exports.VideoGroup = void 0;
const state_flow_1 = require("../state-flow");
//#endregion
//#region Group Declaration
exports.VideoGroup = state_flow_1.PlayerStateFlow.registerGroup("video").bootstrap(() => {
    return (0, exports.NotApplicable)({ filter: null, poster: null });
});
//#endregion
//#region Signals Handlers
//#endregion
//#region States Declarations
exports.NotApplicable = exports.VideoGroup.registerState("NotApplicable", {});
exports.Paused = exports.VideoGroup.registerState("Disabled", {});
exports.Playing = exports.VideoGroup.registerState("Enabled", {});
exports.BlankScreen = exports.VideoGroup.registerState("BlankScreen", {});
exports.VideoError = exports.VideoGroup.registerState("VideoError", {});
//#endregion
//# sourceMappingURL=video.js.map